import { baseApi } from 'core/api';

const state = () => ({
    _mappingItems: [],
    _mappingLoading: false,
    _mappingIsEmpty: true,
    _mappingAddError: false,
});

const getters = {
    intercomMappingItems: (state) => state._mappingItems,
    intercomMappingLoading: (state) => state._mappingLoading,
    intercomMappingIsEmpty: (state) => state._mappingIsEmpty,
    intercomMappingAddError: (state) => state._mappingAddError,
};

const actions = {
    async intercomMappingLoad() {
        if (this._mappingLoading) return;

        this._setIntercomMappingLoad();

        return baseApi
            .get('core/core/messenger/mapping', {
                params: { integration: 'intercom' },
            })
            .then((response) => {
                const ids = Object.values(response.data.mapping);
                this._setIntercomMappingLoaded({
                    mapping: ids[0],
                });

                return ids[0];
            })
            .catch((error) => {
                this._setIntercomMappingLoadError(error);

                return error;
            });
    },

    intercomMappingAdd(inboxes) {
        const params = {
            integration: 'intercom',
            inboxes: inboxes,
        };

        return baseApi
            .post('core/core/messenger/mapping/add', params)
            .then((response) => {
                this._setIntercomMappingAdd(inboxes);

                return response.data;
            })
            .catch((error) => {
                this._setIntercomMappingAddError(error);

                return error;
            });
    },

    // Private methods
    _setIntercomMappingLoad() {
        this._mappingLoading = true;
        this._mappingLoadingError = false;
    },

    _setIntercomMappingLoaded({ mapping }) {
        this._mappingLoading = false;
        this._mappingLoadingError = false;
        this._mappingItems = mapping;
        this._mappingIsEmpty = Boolean(!mapping.length);
    },

    _setIntercomMappingLoadError() {
        this._mappingLoading = false;
        this._mappingLoadingError = true;
        this._mappingItems = [];
    },

    _setIntercomMappingAdd(mapping) {
        this._mappingItems = mapping;
    },

    _setIntercomMappingAddError() {
        this._mappingAddError = true;
    },
};

export default {
    state,
    getters,
    actions,
};
